import { lazy } from 'react';

import { ALLOWED_ROLES } from '@src/packages/utils';

import { PATHS } from './constants';

const OperationalPanel = lazy(() => import('./screens/OperationalPanel'));

const operationalPanelRoutes = [
  {
    component: OperationalPanel,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.OPERATIONAL_PANEL.OPERATION,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default operationalPanelRoutes;
